import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Form, FormControl } from '@angular/forms';
import { ApiVisa, GlcodeContainerModel, GlcodeService } from 'blg-akaun-ts-lib';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppConfig } from '../../shared-utilities/visa';

@Component({
  selector: 'blg-select-glcode-drop-down',
  templateUrl: './select-glcode-drop-down.component.html',
  styleUrls: ['./select-glcode-drop-down.component.scss']
})

export class SelectGlcodeDropDownComponent implements OnInit, OnDestroy {

  apiVisa = AppConfig.apiVisa;
  @Input() glcode = new FormControl();
  @Input() required: boolean;

  @Output() glcodeChange = new EventEmitter<FormControl>();
  @Output() glcodeSelected = new EventEmitter<GlcodeContainerModel>();

  serverSideFiltering = new FormControl();
  serverSideSearching = false;
  filteredOptions$: ReplaySubject<GlcodeContainerModel[]> = new ReplaySubject<GlcodeContainerModel[]>(1);
  glcodeList: GlcodeContainerModel[] = [];
  selectedGlcode: GlcodeContainerModel;
  filteredGlcode: any = [];

  protected _onDestroy = new Subject<void>();

  constructor(
    private glcodeService: GlcodeService
  ) {
  }

  ngOnInit() {
    if (this.glcode.value) {
      this.glcodeService.getByGuid(this.glcode.value, this.apiVisa).pipe(
        takeUntil(this._onDestroy)
      ).subscribe( resolved => {
        // this.glcodeList = [resolved.data];
        this.filteredOptions$.next([resolved.data]);
        this.onSelect(resolved.data.bl_fi_mst_glcode.guid.toString());
      });
    }
    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterGlcode();
      });

    this.getGlcode();
  }

  getGlcode() {
    this.glcodeService.get(this.apiVisa).subscribe((x: any) => {
      x.data.forEach((data) => {
        this.filteredGlcode.push(data);
        this.glcodeList.push(data);
      });

      // sorting
      const sorted = this.filteredGlcode.sort((a, b) => (a.bl_fi_mst_glcode.gl_code_1 < b.bl_fi_mst_glcode.gl_code_1 ? -1 : 1));

      this.filteredOptions$.next(this.filteredGlcode.slice());
    });
  }

  filterGlcode() {
    if (!this.filteredGlcode) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.filteredGlcode.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the glcodes
    this.filteredOptions$.next(
      this.filteredGlcode.filter((option) =>
        (option.bl_fi_mst_glcode.gl_code_1 ?
          option.bl_fi_mst_glcode.gl_code_1.toLowerCase().indexOf(search) > -1 : null) ||
        (option.bl_fi_mst_glcode.name ?
          option.bl_fi_mst_glcode.name.toLowerCase().indexOf(search) > -1 : null))
    );
  }

  onSelect(glcodeGuid: string) {
    if (glcodeGuid) {
      this.glcode.patchValue(glcodeGuid);
      this.selectedGlcode = this.glcodeList.find(glcode => glcode.bl_fi_mst_glcode.guid === glcodeGuid);
      this.glcodeSelected.emit(this.selectedGlcode);
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}
